<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/evaluationTeam/acceptanceDesignation/${inputs.id}`
            : `/evaluationTeam/acceptanceDesignation`
        "
      >
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>Designación de equipo evaluador</label>
              <div>
                <button class="btn btn-success" @click.prevent="openTab()">
                  Descargar
                </button>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="showSamplingPlanFile">
            <div class="form-group">
              <label>Plan de muestreo</label>
              <div>
                <button
                  class="btn btn-success"
                  @click.prevent="openTabMuestreo()"
                >
                  Descargar
                </button>
              </div>
            </div>
          </div>
          <br /><br />
        <!--
          <div class="col-12">
            <legend class="col-12 col-form-label text-primary pt-0 mb-3">
              <label>Observaciones anteriores:</label>
            </legend>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">Observación</th>
                  <th scope="col">Usuario</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, i) in observations" :key="i">
                  <td class="align-middle">
                    {{ value.created_at.slice(0, 10) }}
                  </td>
                  <td class="align-middle">
                    {{ value.observation }}
                  </td>
                  <td class="align-middle">
                    {{ value.first_name }} {{ value.last_name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Planificado desde</label>
              <app-input
                type="text"
                v-model="extras.date_start"
                :disabled="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Planificado hasta</label>
              <app-input
                type="text"
                v-model="extras.date_end"
                :disabled="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Confirmar</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_confirmed"
                :list="isActive"
                @input="clicked"
                
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="showObservation">
          <div class="col-6">
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-12 mb-0">
                <h5 class="card-title m-0">Observación</h5>
                <br />
              </label>
              <app-input
                id="inputs_observations"
                class="col-sm-12"
                type="textarea"
                v-model="inputs.observations"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
  },
  data() {
    return {
      preloader: false,
      showSamplingPlanFile: false,
      inputs: {
        is_confirmed: 0,
      },
      observations: [],
      showObservation: false,
      extras: {},
      modalId: "modal-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",

        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(res) {
      this.observations = res.data.observations;
      this.inputs.id = res.data.id;
      // this.inputs.is_confirmed = res.data.is_confirmed ? 1 : 0;
      this.inputs.is_confirmed = 1;
      this.extras.date_start = `${res.data.evaluation_testification.date_start} ${res.data.evaluation_testification.time_start}`;
      this.extras.date_end = `${res.data.evaluation_testification.date_end} ${res.data.evaluation_testification.time_end}`;
      this.extras.evaluation_team_designation =
        res.data.evaluation_team_designation;
      this.preloader = false;
      this.extras.sampling_plan_file = `${res.data.evaluation_testification.sampling_plan_file.path}`;
      if (res.data.area == "LABORATORIOS") {
        this.showSamplingPlanFile = true;
      } else {
        this.showSamplingPlanFile = false;
      }
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    openTab() {
      const w = window.open(
        this.extras.evaluation_team_designation.path,
        "_blank"
      );
      w.focus();
    },
    openTabMuestreo() {
      const w = window.open(this.extras.sampling_plan_file, "_blank");
      w.focus();
    },
    clicked() {
      if (this.inputs.is_confirmed == 0) {
        // NO
        this.showObservation = true;
      } else {
        this.showObservation = false;
      }
    },
  },
};
</script>
